import { FallbackReportService } from './local-service/fallback-report.service';
import { Component, OnInit } from '@angular/core';

import { TabLabel } from './table-nav/table-nav.component';

@Component({
  selector: 'app-fallback-report',
  templateUrl: './fallback-report.component.html',
  styleUrls: ['./fallback-report.component.scss']
})
export class FallbackReportComponent implements OnInit {
  get endpoint () {
    return this.localService.endpoint;
  }
  get isShowMore() {
    return this.localService.isShowMore;
  }
  get aceMoreData() {
    return this.localService.aceMoreData;
  }

  constructor(private localService: FallbackReportService) {
    this.localService.selectTabSubject.subscribe(this.onSelectTable.bind(this));
  }

  ngOnInit() {
    this.localService.tabs = this.localService.TabLabels;
    this.localService.tabs[0].payload.isSelected = true;
    this.localService.endpoint = this.localService.tabs[0].payload.endpoint;
  }

  /**
   * CTA action - when a user clicks a tab, selecting a table to view
   * @param tab which tab was clicked
   */
  onSelectTable(tab: TabLabel) {
    this.localService.tabs
      .filter(t => t.payload.endpoint !== tab.payload.endpoint)
      .map(t => delete t.payload.isSelected);
    this.localService.endpoint = tab.payload.endpoint;
  }
}
